<div class="modal fade header-modal" id="{{ modalId }}" data-bs-backdrop="static" data-bs-keyboard="true" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" style="position: static">
    <div id="modalContent" class="modal-content">
      <div class="modal-header">
        <h5 id="staticBackdropLabel" class="modal-title">{{ modalTitle }}</h5>
        <button type="button" (click)="onCloseModal()" id="closeModalBtn" class="btn-close-modal" data-bs-dismiss="modal" aria-label="Close">
          <i class="ti-cross ti-lg"></i>
        </button>
      </div>
      <app-loading *ngIf="loadingService.loading$ | async"></app-loading>
      <div class="modal-body">
        <ng-content select="[modalBody]"></ng-content>
      </div>
      <div class="modal-footer" id="modal-footer" (click)="commonService.modalFooterClicked = true; commonService.selectedId = 0">
        <ng-content select="[modalFooter]"></ng-content>
      </div>
    </div>
  </div>
</div>
